$(document).on 'turbo:load', ->
  $('#panels').on "click.edFeedback", "button.open-educator-feedback", (e) ->
    e.preventDefault()
    $(@).parents('.panel-response').addClass('active')
      .next('.panel-educator-feedback').addClass('active')
      .find('textarea').focus()

  $('#panels').on "click.edFeedback", "button.cancel-educator-feedback", (e) ->
    e.preventDefault()
    $panel = $(@).parents('.panel-educator-feedback')
    if $panel.find('.feedback-list .feedback').length
      $panel.find('.feedback-form').removeClass('active')
      $panel.find('.respond-educator-feedback').addClass('active')
      $panel.find('.feedback-border').addClass('active')
    else
      $panel.removeClass('active')
        .prev('.panel-response').removeClass('active')

  $('#panels').on "click.edFeedback", "button.respond-educator-feedback", (e) ->
    e.preventDefault()
    $panel = $(@).removeClass('active').parents('.panel-educator-feedback')
    $panel.find('.feedback-form').addClass('active')
      .find('textarea').focus()
    $panel.find('.feedback-border').removeClass('active')
    $panel.find('.submit-educator-feedback').removeAttr('disabled')
    # $(@).parents('.jspContainer').scrollTo("#feedback_body")


  $('#panels').on "click.edFeedback", "button.submit-educator-feedback", (e) ->
    form = $(@).parents('form')
    textarea = form.find('textarea')
    if !$.trim(textarea.val())
      e.preventDefault()
      textarea.focus()
